export class ResourceGroupListDTO {
    
    id: string;

    name: string;

    description: string;

}
